"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertGetViemClient = exports.viemClientByNetworkId = exports.viemClientByChainId = exports.viemBaseClient = exports.viemPolygonClient = exports.viemGnosisClient = exports.viemOptimismClient = exports.viemArbitrumNovaClient = exports.viemArbitrumClient = exports.viemAvalancheClient = exports.viemBscClient = exports.viemEthMainnetClient = void 0;
const types_1 = require("@shapeshiftoss/types");
const assert_1 = __importDefault(require("assert"));
const viem_1 = require("viem");
const chains_1 = require("viem/chains");
exports.viemEthMainnetClient = (0, viem_1.createPublicClient)({
    chain: chains_1.mainnet,
    transport: (0, viem_1.fallback)(
    // https://github.com/DefiLlama/chainlist/blob/83b8cc32ee79c10e0281e1799ebe4cd1696082b7/constants/llamaNodesRpcs.js
    [process.env.REACT_APP_ETHEREUM_NODE_URL, 'https://eth.llamarpc.com']
        .filter(Boolean)
        .map(url => (0, viem_1.http)(url))),
});
exports.viemBscClient = (0, viem_1.createPublicClient)({
    chain: chains_1.bsc,
    transport: (0, viem_1.fallback)(
    // https://github.com/DefiLlama/chainlist/blob/83b8cc32ee79c10e0281e1799ebe4cd1696082b7/constants/llamaNodesRpcs.js#L30
    [process.env.REACT_APP_BNBSMARTCHAIN_NODE_URL, 'https://binance.llamarpc.com']
        .filter(Boolean)
        .map(url => (0, viem_1.http)(url))),
});
exports.viemAvalancheClient = (0, viem_1.createPublicClient)({
    chain: chains_1.avalanche,
    transport: (0, viem_1.fallback)(
    // https://github.com/DefiLlama/chainlist/blob/83b8cc32ee79c10e0281e1799ebe4cd1696082b7/constants/extraRpcs.js#L937
    [process.env.REACT_APP_AVALANCHE_NODE_URL, 'https://api.avax.network/ext/bc/C/rpc']
        .filter(Boolean)
        .map(url => (0, viem_1.http)(url))),
});
exports.viemArbitrumClient = (0, viem_1.createPublicClient)({
    chain: chains_1.arbitrum,
    transport: (0, viem_1.fallback)(
    // https://github.com/DefiLlama/chainlist/blob/83b8cc32ee79c10e0281e1799ebe4cd1696082b7/constants/llamaNodesRpcs.js#L63
    [process.env.REACT_APP_ARBITRUM_NODE_URL, 'https://arbitrum.llamarpc.com']
        .filter(Boolean)
        .map(url => (0, viem_1.http)(url))),
});
exports.viemArbitrumNovaClient = (0, viem_1.createPublicClient)({
    chain: chains_1.arbitrumNova,
    transport: (0, viem_1.fallback)(
    // https://github.com/DefiLlama/chainlist/blob/83b8cc32ee79c10e0281e1799ebe4cd1696082b7/constants/extraRpcs.js#L1393
    [process.env.REACT_APP_ARBITRUM_NOVA_NODE_URL, 'https://nova.arbitrum.io/rpc']
        .filter(Boolean)
        .map(url => (0, viem_1.http)(url))),
});
exports.viemOptimismClient = (0, viem_1.createPublicClient)({
    chain: chains_1.optimism,
    transport: (0, viem_1.fallback)(
    // https://github.com/DefiLlama/chainlist/blob/83b8cc32ee79c10e0281e1799ebe4cd1696082b7/constants/llamaNodesRpcs.js#L41
    [process.env.REACT_APP_OPTIMISM_NODE_URL, 'https://optimism.llamarpc.com']
        .filter(Boolean)
        .map(url => (0, viem_1.http)(url))),
});
exports.viemGnosisClient = (0, viem_1.createPublicClient)({
    chain: chains_1.gnosis,
    transport: (0, viem_1.fallback)(
    // https://github.com/DefiLlama/chainlist/blob/83b8cc32ee79c10e0281e1799ebe4cd1696082b7/constants/extraRpcs.js#L1978
    [process.env.REACT_APP_GNOSIS_NODE_URL, 'https://rpc.gnosischain.com']
        .filter(Boolean)
        .map(url => (0, viem_1.http)(url))),
});
exports.viemPolygonClient = (0, viem_1.createPublicClient)({
    chain: chains_1.polygon,
    transport: (0, viem_1.fallback)(
    // https://github.com/DefiLlama/chainlist/blob/83b8cc32ee79c10e0281e1799ebe4cd1696082b7/constants/llamaNodesRpcs.js#L52
    [process.env.REACT_APP_POLYGON_NODE_URL, 'https://polygon.llamarpc.com']
        .filter(Boolean)
        .map(url => (0, viem_1.http)(url))),
});
exports.viemBaseClient = (0, viem_1.createPublicClient)({
    chain: chains_1.base,
    transport: (0, viem_1.fallback)(
    // https://github.com/DefiLlama/chainlist/blob/83b8cc32ee79c10e0281e1799ebe4cd1696082b7/constants/llamaNodesRpcs.js#L19
    [process.env.REACT_APP_BASE_NODE_URL, 'https://base.llamarpc.com']
        .filter(Boolean)
        .map(url => (0, viem_1.http)(url))),
});
exports.viemClientByChainId = {
    [types_1.KnownChainIds.EthereumMainnet]: exports.viemEthMainnetClient,
    [types_1.KnownChainIds.BnbSmartChainMainnet]: exports.viemBscClient,
    [types_1.KnownChainIds.AvalancheMainnet]: exports.viemAvalancheClient,
    [types_1.KnownChainIds.ArbitrumMainnet]: exports.viemArbitrumClient,
    [types_1.KnownChainIds.ArbitrumNovaMainnet]: exports.viemArbitrumNovaClient,
    [types_1.KnownChainIds.GnosisMainnet]: exports.viemGnosisClient,
    [types_1.KnownChainIds.PolygonMainnet]: exports.viemPolygonClient,
    [types_1.KnownChainIds.OptimismMainnet]: exports.viemOptimismClient,
    [types_1.KnownChainIds.BaseMainnet]: exports.viemBaseClient,
};
exports.viemClientByNetworkId = {
    [chains_1.mainnet.id]: exports.viemEthMainnetClient,
    [chains_1.bsc.id]: exports.viemBscClient,
    [chains_1.avalanche.id]: exports.viemAvalancheClient,
    [chains_1.arbitrum.id]: exports.viemArbitrumClient,
    [chains_1.arbitrumNova.id]: exports.viemArbitrumNovaClient,
    [chains_1.gnosis.id]: exports.viemGnosisClient,
    [chains_1.polygon.id]: exports.viemPolygonClient,
    [chains_1.optimism.id]: exports.viemOptimismClient,
    [chains_1.base.id]: exports.viemBaseClient,
};
const assertGetViemClient = (chainId) => {
    const publicClient = exports.viemClientByChainId[chainId];
    (0, assert_1.default)(publicClient !== undefined, `no public client found for chainId '${chainId}'`);
    return publicClient;
};
exports.assertGetViemClient = assertGetViemClient;
